import { defineComponent } from '@vue/composition-api';
import DetailDiff from '@components/version/detailDiff.vue';
import styles from './styles/mergeModal.module.scss';
import ConflictView from './ConflictView';
import AIConflictView from './AIConflictView';
// 常量定义
const AI_PROJECT_INFO_SCHEMA_KEY = '_wuji_xy:ai_project_info';
export default defineComponent({
    name: 'MergeView',
    components: {
        DetailDiff,
    },
    props: {
        change: {
            type: Object,
            default: () => { },
        },
        currentBranch: {
            type: String,
            default: '',
        },
        mergeBranch: {
            type: String,
            default: '',
        },
    },
    emits: ['change'],
    data() {
        return {};
    },
    watch: {},
    methods: {
        onChangeConflict(result) {
            // 支持两种格式：普通字符串 或 带 resolved 标志的对象
            const isResolved = typeof result === 'object' && result.resolved;
            const data = typeof result === 'object' ? result.data : result;
            this.$emit('change', {
                ...this.change,
                // 如果明确标记为已解决，则更新 conflict 状态
                conflict: isResolved ? false : this.change.conflict,
                content: {
                    ...this.change.content,
                    after: data,
                },
            });
        },
    },
    render() {
        const isAIProjectInfo = this.change.schemaKey === AI_PROJECT_INFO_SCHEMA_KEY;
        return (<div style={{
                overflow: 'hidden',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
            }}>
        {!this.change.conflict && !isAIProjectInfo && <DetailDiff class={styles.editor_diff_detail} type="yaml" originalData={this.change.content.before} modifiedData={this.change.content.after}/>}
        {this.change.conflict && !isAIProjectInfo && <ConflictView class={styles.editor_diff_detail} onChange={this.onChangeConflict} conflictItem={this.change.content} key={this.change.key} currentBranchLabel={this.currentBranch} mergeBranchLabel={this.mergeBranch}/>}
        {isAIProjectInfo && <AIConflictView class={styles.editor_diff_detail} conflictItem={this.change.content} key={this.change.key} currentBranchLabel={this.currentBranch} mergeBranchLabel={this.mergeBranch} resolved={!this.change.conflict} onChange={this.onChangeConflict}/>}
      </div>);
    },
});
